
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/central-de-ajuda",
      function () {
        return require("private-next-pages/central-de-ajuda/index.tsx");
      }
    ]);
  